import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BettingTips } from "@api-types/bet-booster/BettingTipsType";

import BettingTipQuotaButton from "./BettingTipQuotaButton";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { OfferStoreContext } from "@gp/components";

import { formatTip, formatType } from "@utils/common/bettingTipsUtils";
import BettingTipsTeams from "./BettingTipsTeams";

export default observer(function BettingTipsCard(props: { data: BettingTips }) {
	const store = useContext(OfferStoreContext) as
		| AdditionalOfferViewStore
		| EventViewStore;

	const isEventCard =
		store instanceof AdditionalOfferViewStore ||
		store instanceof EventViewStore;

	return (
		<>
			<div className="card__header card--bbt__header card--bbt--nowrap__header">
				<i className="u-icon u-icon--sml u-icon--betting-tip--str u-color--bet--returned u-mar--right--xtny" />
				<div className="card--bbt__description card--bbt--nowrap__description">
					{props.data.description}
				</div>
			</div>

			<div className="card--qp__body card--bbt__body">
				{!isEventCard && <BettingTipsTeams data={props.data} />}

				<div className="card--qp__offer card--bbt__offer">
					<div className="card--qp__item card--bbp__item card--bbp--nowrap__item">
						{/* <div className="card--qp__track card--bbp__track" /> */}

						<div className="card--qp__market card--bbt__market card--qp--nowrap__market card--bbt--nowrap__market">
							<span className="card--qp__type card--bbt__type card--qp--nowrap__type card--bbt--nowrap__type">
								{formatType(props.data)}
							</span>
							:
							<span className="card--qp__tip card--bbt__tip card--qp--nowrap__tip card--bbt--nowrap__tip">
								{formatTip(props.data)}
							</span>
						</div>
					</div>
				</div>

				<BettingTipQuotaButton tip={props.data} />
			</div>
		</>
	);
});
